import { InfoOutlineIcon } from "@tandemdiabetes/sugarmate-react-components"

import styles from "./DataSource.module.scss"
import { usePolyglot } from "src/contexts"

const polyglotPrefix = "pages.settings.data_source.tandem_notice."

export function TandemNotice() {
  const polyglot = usePolyglot()
  return (
    <div className={styles.tandemNoticeContainer}>
      <InfoOutlineIcon className={styles.infoIcon} />
      <span>
        <span className={styles.noticeReminder}>
          {polyglot.t(`${polyglotPrefix}reminder`)}
        </span>
        <span className={styles.noticeDescription}>
          {": "}
          {polyglot.t(`${polyglotPrefix}notice`)}
        </span>
      </span>
    </div>
  )
}
